<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';
import BoConfig from '@config/BoConfig.js';

export default {
  extends: Base,
  data() {
    return {
      Name: "FlowStatusReport",
      PageName: "Flow Status Report",
      ObjectName: "Flow Status Report",
      NoList: true,
      detail: {},
      emp: {},
      apc: {},
      arr: {},
      FlowHistory: [],
      input: {},
      mrValidation: {},
      facilitySetup: []
    }
  },
  computed: {
    aiStatus() {
      return BoConfig.aiStatus
    },
    deptAdmin() {
      return this.FlowHistory.filter(v => {
        return v.role == "Department Admin";
      })[0] || {}
    },
  },
  mounted() {
    this.$set(this.$root, 'page', this)
    this.changeHeaderInfo()
    this.refreshData()
  },
  methods: {
    changeHeaderInfo() {
      if (this.$route.name == "RecruitmentReport") {
        this.Name = "RecruitmentReport";
        this.PageName = "Recruitment Report";
        this.ObjectName = "Recruitment Report";
      } else {
        this.Name = "FlowStatusReport";
        this.PageName = "Flow Status Report";
        this.ObjectName = "Flow Status Report";
      }
    },
    activityNameMsg(v) {
      if (this.isServicesRole) return "Related Working Facility"
      return this.aiStatus[v.ai_status]
    },
    notesMsg(v) {
      if (v.aal.aal_remarks) return v.aal.aal_remarks
      if (v.ai_status == "WFS") return "Set Up Working Facility"
      return "Onboarding Approval"
    },
    openDetailFlowStatus(v) {
      this.detail = v
      if (v.ai_type == "recruitment") {
        this.apiPRFHistory();
      } else {
        this.apiFlowDetail();
      }
      $("#FlowStatus").modal()
    },
    openResendEmail(v) {
      this.detail = v
      this.input = {
        cwid: v.toEmp.cwid
      }
      this.sendEmail(this.detail)
    },
    isResendEmail(v) {
      return ['SRF', 'SCD', 'DONE', 'REJECTED', 'REJECT'].indexOf(v.ai_status) == -1
    },
    apiPRFHistory() {
      this.loadingOverlay = true
      BOGen.apirest("/RecruitmentDetail", {
        request_number: this.detail.ai_request_number,
        apc_id: this.detail.apc_id
      }, (err, resp) => {
        this.loadingOverlay = false
        if (err) return console.error(err)
        this.detail = resp.data
        this.apc = resp.apc
        this.arr = resp.arr
      })
      BOGen.apirest("/PRFHistory", {
        request_number: this.detail.ai_request_number,
        apc_id: this.detail.apc_id
      }, (err, resp) => {
        if (err) return console.error(err);
        this.FlowHistory = resp.data
      })
    },
    apiFlowDetail() {
      this.loadingOverlay = true
      BOGen.apirest("/FlowStatusDetail", {
        request_number: this.detail.ai_request_number,
        apc_id: this.detail.apc_id
      }, (err, resp) => {
        this.loadingOverlay = false
        if (err) return console.error(err)
        this.detail = resp.ai
        this.emp = resp.emp
        this.FlowHistory = resp.history.filter(h => h.cwid && h.cwid != '-')
        this.facilitySetup = resp.facilitySetup


        const waitingObj = {
          step: this.FlowHistory.filter(v => v.cwid).length,
          cwid: "-",
          employeename: "-",
          status: null,
          remarks: '-',
          email: '-'
        }

        if (resp.ai.ai_status == "APA") {
          const approvalAdminHistory = this.FlowHistory.filter(fh => fh.type == "APA")
          if(this.ai_both_admin_approved == "0" && approvalAdminHistory.length < 1){
            this.FlowHistory.push(Object.assign(waitingObj, {
              flow: "Approval Admin"
            }))
          } else if(this.ai_both_admin_approved == "0" && approvalAdminHistory.length == 1){
            this.FlowHistory.push(Object.assign(waitingObj, {
              flow: "Approval Admin"
            }))
          }
        } else if (resp.ai.ai_status == "ADC") {
          this.FlowHistory.push(Object.assign(waitingObj, {
            flow: "Attachment Approval",
            employeename: resp.documentation.employeename,
            cwid: resp.documentation.cwid,
            email: resp.documentation.email
          }))
        } else if (resp.ai.ai_status == "SPV") {
          this.FlowHistory.push(Object.assign(waitingObj, {
            flow: "Approval Requester",
            employeename: resp.requester.employeename,
            cwid: resp.requester.cwid,
            email: resp.requester.email
          }))
        }
      })
    },
    sendEmail(v) {
      swal({
        title: "Are you sure to resend email?",
        text: "",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if (!ok) return;
        if (this.loadingOverlay) return;
        this.loadingOverlay = true
        this.input.request_number = v.ai_request_number;
        this.input.apc_id = v.apc_id;
        if (!v.apc_id) delete this.input.apc_id;
        BOGen.apirest("/FlowStatusReport/resend-email", this.input, (err, resp) => {
          this.loadingOverlay = false
          if (err) return console.error(err)
          this.refreshData()
          swal("Successful", "Email has been sent", "success").then(() => {
            $(".modal").modal("hide")
          })
        }, "POST")
      })
    },
    resultDataCwid(data) {
      var items = [];
      data.data.forEach((x) => {
        items.push({
          id: x.cwid,
          text: (x.cwid ? x.cwid + " | " : "") + x.employeename + " " + (x.position ? "(" + x.position + ")" : ""),
        })
      })
      return {
        results: items
      }
    },
    downloadExcelUrl(type = '') {
      var params = {}
      if (this.filter.startdate) params.startdate = moment(this.filter.startdate, 'DD-MM-YYYY').format("YYYY-MM-DD")
      if (this.filter.enddate) params.enddate = moment(this.filter.enddate, 'DD-MM-YYYY').format("YYYY-MM-DD")
      return this.baseUrl + "/api/" + this.Name + "?downloadExcel=true" + (type ? "&type=" + type : "") + "&" + Gen.objectToQuery(params) + "&token=" + Gen.getCookie("botk")
    }
  },
  watch: {
    '$route.query'(v) {
      this.changeHeaderInfo()
      this.refreshData()
    },
    'filter.startdate'(v) {
      if (this.filter.enddate) this.search()
      if (global.moment(this.filter.startdate, 'DD-MM-YYYY').isAfter(global.moment(this.filter.enddate, 'DD-MM-YYYY')) || !this.filter.enddate) this.$set(this.filter, 'enddate', this.filter.startdate)
    },
    'filter.enddate'(v, b) {
      if (global.moment(this.filter.startdate, 'DD-MM-YYYY').isAfter(global.moment(this.filter.enddate, 'DD-MM-YYYY')) || !this.filter.startdate) this.$set(this.filter, 'startdate', this.filter.enddate)
      if (b) this.search()
    }
  }
}
</script>

<template>
<div class="container-fluid">
  <PageTitle></PageTitle>

  <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
  <div class="card" v-if="!$route.params.id">
    <div class="card-body card-filter">
      <VForm @resp="search">
        <div class="row">
          <div class="col-sm-3">
            <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
          </div>
          <div class="col-sm-5">
            <div class="input-daterange input-group">
              <DatePicker v-model="filter.startdate" :config="{startDate:'-2y'}" @keyup.enter="search" placeholder="Start Date"></DatePicker>
              <div class="input-group-append">
                <span class="input-group-text bg-info b-0 text-white">TO</span>
              </div>
              <DatePicker v-model="filter.enddate" :config="{startDate:'-2y'}" @keyup.enter="search" placeholder="End Date"></DatePicker>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="has-feedback has-feedback-left">
              <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
              <div class="form-control-feedback">
                <i class="icon-search4 text-size-base text-muted"></i>
              </div>
            </div>
          </div>
          <div class="col-sm-1">
            <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
          </div>
        </div>
      </VForm>
    </div>
    <div class="table-responsive ajax-table mt-3">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>
              <SortField name="reqno" :label="fields.ai_request_number"></SortField>
            </th>
            <th>
              <SortField name="department" :label="fields.ai_msg_id"></SortField>
            </th>
            <!-- <th><SortField name="reqno" lebel="">Company</th> -->
            <th>
              <SortField name="reqdate" :label="fields.ai_request_date"></SortField>
            </th>
            <th>
              <SortField name="reqfor" label="Request For"></SortField>
            </th>
            <th>
              <SortField name="employeename" label="Employee Name"></SortField>
            </th>
            <th>
              <SortField name="status" label="Status"></SortField>
            </th>
            <th>
              <SortField name="createname" label="Create"></SortField>
            </th>
            <th width="100px">Email</th>
            <th width="60px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v,k) in data.data" :key="k">
            <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
            <td>
              {{v.ai_request_number}}
            </td>
            <td>
              {{v.department}}
            </td>
            <!-- <td>Bayer Indonesia</td> -->
            <td>{{(v.ai_created_at||"").dates('format2')}}</td>
            <td>{{v.request_for}}</td>
            <td>{{v.employeename||"-"}}</td>
            <td>
              <StatusLabel :obj="v"></StatusLabel>
            </td>
            <td>{{v.created_name}}</td>
            <template>
              <td class="btn-action tc" v-if="v.ai_created_by==user.cwid && user.access_level != 6">
                <button class="btn btn-success btn-sm" @click="openResendEmail(v)" v-if="isResendEmail(v)"><i class="fa fa-mail-forward"></i> Resend Email</button>
                <span class="text-left d-block" v-else>-</span>
              </td>
              <!-- dept head / n dept head -->
              <td class="btn-action tc" v-else-if="(v.aa.aa_manager_cwid==user.cwid || v.aa.aa_nmanager_cwid==user.cwid) && user.access_level == 6">
                <button class="btn btn-success btn-sm" @click="openResendEmail(v)" v-if="isResendEmail(v)"><i class="fa fa-mail-forward"></i> Resend Email </button>
                <span class="text-left d-block" v-else>-</span>
              </td>
              <td v-else>
                <span>-</span>
              </td>
            </template>
            <td class="btn-action tc">
              <button class="btn btn-info btn-sm btn-circle" v-tooltip="'Detail flow status'" @click="openDetailFlowStatus(v)" v-if="v.aa"><i class="fa icon-eye"></i></button>
              <span v-else>-</span>
            </td>
          </tr>
          <tr v-if="NotFound">
            <td colspan="99">
              <h3 class="tc">{{NotFound}}</h3>
            </td>
          </tr>
          <tr v-if="data.data===false">
            <td colspan="99">
              <LoadingSpinner light></LoadingSpinner>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-body">
      <div class="pull-left">
        <a v-if="$route.name=='RecruitmentReport'" :href="downloadExcelUrl('recruitment')" class="btn btn-success waves-effect waves-light"><i class="icon-cloud-download"></i> Export Excel</a>
        <template v-else>
          <a v-if="data.total" :href="downloadExcelUrl()" class="btn btn-success waves-effect waves-light"><i class="icon-cloud-download"></i> Export Excel</a>
        </template>
      </div>
      <div class="pull-right">
        <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
      </div>
    </div>
  </div>

  <div id="FlowStatus" class="modal">
    <div class="modal-dialog modal-lg" style="max-width: 100%;" v-if="detail.ai_request_number">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myLargeModalLabel">Detail {{ $route.name == "RecruitmentReport" ? "Recruitment Report" : "Flow Status Report" }}</h4>
        </div>
        <div class="modal-body">
          <h4 class="mb-3">Request Number : {{detail.ai_request_number}}</h4>
          <div class="row">
            <div class="col-md-9">
              <div class="row lblfield">
                <div class="col-sm-3">
                  <BoField name="employeename">{{emp.employeename||apc.apc_fullname||"-"}}</BoField>
                </div>
                <div class="col-sm-3">
                  <BoField name="ai_bg_id">{{detail.ai_division||emp.division}}</BoField>
                </div>
                <div class="col-sm-3">
                  <BoField name="ai_msg_id">{{detail.ai_department||emp.department}}</BoField>
                </div>
                <div class="col-sm-3">
                  <BoField name="ai_position">{{detail.ai_position||emp.position}}</BoField>
                </div>
                <template v-if="detail.ai_type=='recruitment'">
                  <div class="col-sm-3" v-if="apc.apc_cv_file">
                    <BoField label="CV Document">
                      <ImagePreview :src="uploader(apc.apc_cv_file)"> Open File</ImagePreview>
                    </BoField>
                  </div>
                  <div class="col-sm-3" v-if="arr.arr_personal_data_file">
                    <BoField label="Personal Data Document">
                      <ImagePreview :src="uploader(arr.arr_personal_data_file)"> Open File</ImagePreview>
                    </BoField>
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-3">
                    <BoField name="cwid">{{emp.cwid}}</BoField>
                  </div>
                  <div class="col-sm-3">
                    <BoField name="ai_cc_id">{{detail.ai_costcenter||emp.costcenter}}</BoField>
                  </div>
                  <div class="col-sm-3">
                    <BoField name="ai_mws_id">{{emp.workstatus||"-"}}</BoField>
                  </div>
                  <div class="col-sm-3" v-if="detail.ai_type=='onboarding'">
                    <BoField label="Department Admin">{{deptAdmin.employeename}}</BoField>
                  </div>
                </template>
              </div>
            </div>

            <div class="col-md-12" v-if="(facilitySetup||[]).length">
              <div class="border p-3">
                <h3 class="font-weight-bold">Facilty</h3>
                <div v-for="(v, k) in facilitySetup" :key="k" class="mt-3">
                  <h6 class="mb-0 font-weight-bold"><strong>{{ v.facility_name }}</strong></h6>
                  <hr>
                  <div v-for="(v2, k2) in v.afs_answer" :key="k2">
                    <template v-if="v.facility_type == 'checkbox_title'">
                      <div class="facilities mr-2" v-if="(v2.options||[]).length">
                        <h6>{{ v2.title }}</h6>
                        <template v-for="(facility, kfacility) in v2.options">
                          <div class="facility-item mr-2" :key="kfacility">
                            <i class="icon-check"></i>
                            <span>{{ facility }}</span>
                          </div>
                        </template>
                      </div>
                    </template>

                    <template v-if="v.facility_type == 'checkbox'">
                      <div class="facilities mr-2">
                        <div class="facility-item">
                          <i class="icon-check"></i>
                          <span>{{ v2 }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Step</th>
                  <th>CWID</th>
                  <th>Employee Name</th>
                  <th>Email</th>
                  <th>Flow Status</th>
                  <th>Confirm Date</th>
                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(v,k) in FlowHistory.filter(v => v.cwid)">
                  <tr :key="k">
                    <td>{{k+1}}</td>
                    <td>{{v.cwid}}</td>
                    <td>{{v.employeename}}</td>
                    <td>{{v.email}}</td>
                    <template>
                      <td v-if="k==1 && detail.ai_type == 'movement'">{{FlowHistory.length != 2 ? v.flow : "Approval Manager"}}</td>
                      <td v-else>{{v.flow}}</td>
                    </template>
                    <td>{{(v.confirm_date||"").dates("format2")||"-"}}</td>
                    <td>
                      <StatusLabel type="FlowStatus" :obj="v"></StatusLabel>
                    </td>
                    <td>{{v.remarks||"-"}}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-invers waves-effect text-left" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
